function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <path
        d="M7.88664 14.3333C11.5685 14.3333 14.5533 11.3486 14.5533 7.66667C14.5533 3.98477 11.5685 1 7.88664 1C4.20474 1 1.21997 3.98477 1.21997 7.66667C1.21997 11.3486 4.20474 14.3333 7.88664 14.3333Z"
        stroke="#DC2626"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.88696 3.66663V7.66663L10.5536 8.99996"
        stroke="#DC2626"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default ClockIcon;
